import { render } from "./phone-number-select.vue?vue&type=template&id=44ed177c&scoped=true"
import script from "./phone-number-select.vue?vue&type=script&lang=js"
export * from "./phone-number-select.vue?vue&type=script&lang=js"

import "./phone-number-select.vue?vue&type=style&index=0&id=44ed177c&lang=scss"
import "./phone-number-select.vue?vue&type=style&index=1&id=44ed177c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.16_vue@3.5.13_typescript@5.1.6__webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44ed177c"]])

export default __exports__